.edition-link-tracking-table-container {
    background-color: var(--white);
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
}

.edition-link-tracking-table-container > :first-child {
    width: 100% !important;
}
